/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  StyleSheet,
  ImageBackground,
  Dimensions,
  Pressable,
  AppState,
} from "react-native";
import AndroidOpenSettings from "react-native-android-open-settings";
import { requestNotifications } from "react-native-permissions";
import analytics from "@services/analytics";

const { width } = Dimensions.get("window");

const SettingsCard = ({
  image_dimension_width = 1,
  image_dimension_height = 1,
  sub_type = "",
  image_link = "",
  navigation = {},
}) => {
  const [showBanner, setShowBanner] = useState(null);
  const [fetchingSettingStatus, setFetchingSettingStatus] = useState(true);

  useEffect(() => {
    const subscription = AppState.addEventListener(
      "change",
      _handleAppStateChange,
    );
    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    checkNotifStatus();
    const willFocusSubscription = navigation.addListener("focus", () => {
      checkNotifStatus();
    });
    return willFocusSubscription;
  }, []);

  const _handleAppStateChange = (nextAppState) => {
    if (nextAppState === "active") {
      checkNotifStatus();
    }
  };

  const checkNotifStatus = () => {
    if (sub_type === "notification") {
      requestNotifications(["alert", "sound"])
        .then(({ status }) => {
          setFetchingSettingStatus(false);
          const BLOCKED = "blocked";
          if (status === BLOCKED) {
            setShowBanner(true);
          } else {
            setShowBanner(false);
          }
        })
        .catch((e) => {
          console.log("notif errror is ", e);
        });
    }
  };

  const handleOpenSettings = () => {
    analytics.trackEvent("open settings", {
      type: sub_type,
    });
    if (sub_type === "notification") {
      try {
        AndroidOpenSettings.appNotificationSettings();
      } catch (e) {
        analytics.trackEvent("open settings error", {
          message: e?.message,
        });
      }
    } else {
      try {
        AndroidOpenSettings[sub_type]();
      } catch (e) {
        analytics.trackEvent("open settings error", {
          message: e?.message,
        });
      }
    }
  };

  const imageHeight = parseInt(image_dimension_height, 10); // widthMinusPadding / aspectRatio;
  const imgSource =
    image_link.charAt(0) === "{"
      ? JSON.parse(image_link).file.response.url
      : image_link;

  if (sub_type === "notification" && showBanner === false) return null;
  if (sub_type === "notification" && fetchingSettingStatus === true)
    return null;

  return (
    <Pressable
      testID="sc-open-settings"
      style={{
        width,
        height: imageHeight,
        paddingHorizontal: 15,
        marginVertical: 4,
      }}
      onPress={handleOpenSettings}
    >
      <ImageBackground
        source={{
          uri: imgSource,
        }}
        style={[styles.imageBackground, { height: imageHeight }]}
      />
    </Pressable>
  );
};

const styles = StyleSheet.create({
  imageBackground: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    opacity: 1,
    overflow: "hidden",
  },
});

export default SettingsCard;
